module.exports = __webpack_public_path__ + "static/media/118.87d7f64a.webp";